import util from '@/utils/index'
import { oAuth, ssoLogin, getRoles } from '@/api/login'
import { configApi } from '@/api/system'
/**
 *
 */
export const change_userInfo = ({ commit }, _userInfo) => {
  commit('CHANGE_USERSCHOOL', _userInfo)
}

export const localLogin = async ({ commit }, params) => {
  let loginFun = null
  if (params.type === 'sso' || params.type === 'zujuan') {
    loginFun = ssoLogin()
  } else if (params.type === 'oauth') {
    loginFun = oAuth(params.token)
  } else {
    return Promise.reject({ code: 601, message: '登录认证不存在' });
  }

  return loginFun.then(async (resp) => {
    if (!resp) {
      return Promise.reject(new Error('401'));
    }
    // 接口返回message命名有两种（msg，message），在此进行兼容
    const msg = resp.msg || resp.message || '登录失败'
    if (resp.code !== 0) {
      return Promise.reject(new Error(msg));
    }
    const user = resp.body
    YJ_REGION_STORAGE.setItem('schoolId', user.schoolId)
    YJ_REGION_STORAGE.setItem('token', user.token)
    await getRoles(user)

    try {
      let response = await configApi.getConfigByTypes(resp.body.schoolId, ['EXAM_OTHER_WATERMARK']);
      if (response.body && response.body.length) {
        sessionStorage.setItem("region-report-watermark", parseInt(response.body[0].configValue));
      }
    } catch (error) {

    }

    return Promise.resolve(user)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/modules/login/actions.js